import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'thank-you-card-banner',
    templateUrl: './thank-you-card.component.html',
    styleUrls: ['./thank-you-card.component.css'],
    standalone: false
})
export class ThankYouCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
